<template>
    <modal-template>
        <div slot="header">
            {{ trans('course_variations.label.assign_learning_contents') }}
        </div>

        <div slot="body">
            <search-bar
            :placeholder="'vuetables.search.placeholder.learning_content'">
            </search-bar>
            <div class="learning-content-assign-table h:margin-top-10">
                <v-client-table
                    :data="table_data"
                    :columns="columns"
                    :options="options"
                    ref="table"
                >
                    <colored-letter-square slot="cls_column"
                        slot-scope="props"
                        :name="props.row.type"
                        :length="1"
                        :color="setColorOfColoredLetterSquare(props.row.type)"
                    >
                    </colored-letter-square>
                </v-client-table>
            </div>

            <div class="label" v-show="disable">{{ trans('course_variations.learning_content.dependency')}}</div>

            <div class="learning-content-assign" v-for="(data) in dependency_data" :key="data.id" v-show="disable">
                <div class="learning-content-assign-row">
                    {{data.name}}
                    <div>
                        <button
                            type="button"
                            class="btn btn--primary"
                            @click="selectDependency(data.id, data.name)"
                            v-show="showAddButton(data.id)"
                        >
                            {{trans('buttons.add')}}
                        </button>
                        <button
                            type="button"
                            class="btn btn--secondary"
                            @click="removeDependency()"
                            v-show="!showAddButton(data.id)"
                        >
                            {{trans('buttons.remove')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <div slot="footer">
            <div class="page-control h:margin-top-4">
                <div class="page-control__element">
                    <button type="button" @click="$emit('close')" class="btn btn--big btn--secondary h:margin-right-4">{{ trans('buttons.cancel') }}</button>
                    <button type="button" :disabled="!disable" @click="submit" class="btn btn--big btn--primary">{{ trans('buttons.ok') }}</button>
                </div>
            </div>
        </div>
    </modal-template>
</template>

<script>
import id from './partials/Id.vue';
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus.js';


    export default {
        props: ['learningContents'],
        data() {
            return {
                table_data: [],
                dependency_data: [],
                dependency:null,
                dependency_name:'',
                selected: [],
                name:'',
                type:'',
                comment:'',
                columns: [
                    'cls_column',
                    'id',
                    'name',
                    'type',
                    'comment'
                ],

                options: {
                    headings: {
                        cls_column: '',
                        id: this.trans('learning_contents.label.id'),
                        name: this.trans('learning_contents.label.name'),
                        comment: this.trans('learning_contents.label.comment'),
                        type: this.trans('learning_contents.label.type'),
                    },

                    texts: {
                        count: this.trans('vuetables.label.countText'),
                        filter: this.trans('vuetables.label.filter'),
                        noResults: this.trans('vuetables.label.loading'),
                        filterPlaceholder: this.trans('vuetables.label.search')
                    },

                    sortable: ['id', 'name', 'type'],

                    templates: {
                        id: id
                    },

                    destroyEventBus: true
                }
            }
        },

        computed: {
            disable() {
                return this.selected != 0;
            }
        },

        created() {
            this.fetch();
        },

        mounted() {
            Event.$on('vue-tables.row-click', (data) => {
                this.setSelectedLearningContentId(data)
            });

            /**
             * Remark selected and obtained dom, wenn pagination is changed.
             */
            Event.$on('vue-tables.pagination', () => {
                this.markSelectedRow()
                this.markObtainedRow()
            });

            var filter = this.debounce((query) => {
                this.$refs.table.setFilter(query);
            }, 500);

            EventBus.$on('onFilter', query => {
                filter(query);
            });
        },

        methods: {
            fetch() {
                axios.get(this.route('mainapi.learning-contents.index')).then(this.refresh);
            },

            refresh({ data }) {
                this.table_data = data.data;

                this.options.texts.noResults = this.trans(
                    'vuetables.label.noResults'
                );

                this.markObtainedRow();

                this.dependency_data = this.table_data.filter(item => {
                    return this.learningContents.includes(item.id)
                });
            },

            setSelectedLearningContentId(e) {
                // Check: selected id has already existed?
                // Prevent duplication submit.
                // Warning: array.includes(...)" function is not supported in IE at all!
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes#Polyfill
                if (!this.learningContents.includes(e.row.id)) {
                    this.selected = e.row.id;
                    this.name = e.row.name;
                    this.comment = e.row.comment;
                    this.type = e.row.type;
                    this.markSelectedRow();
                }
            },

            /**
             * Mark the selected row in the vue-tables
             * When pagination changes, fix the issue, and keep marking the same selected row.
             */
            markSelectedRow() {
                setTimeout(() => {
                    if (this.selected) {
                        // Search current document with classname 'selected'
                        var deleteSelectedClass = document.getElementsByClassName('selected');

                        // If pagination changes, we will find one with the classname, however actually not the same id,
                        // remove that firstly
                        if (deleteSelectedClass.length) {
                            deleteSelectedClass[0].className = '';
                        }

                        // Search current document with selected id, which is stored in the data()
                        var selectedRow = document.getElementById(this.selected);

                        // If found one, which means we are in the correct page, mark it with the 'selected' classname
                        if (selectedRow) {
                            selectedRow.closest('tr').className = 'selected';
                        }
                    }
                }, 0);
            },

            /**
             * Same with markSelectedRow method, but with array to deal with
             */
            markObtainedRow() {
                setTimeout(() => {
                    if (this.learningContents.length) {
                        var deleteObtainedClass = document.getElementsByClassName('obtained');

                        if (deleteObtainedClass.length) {
                            let length = deleteObtainedClass.length;
                            for (let index = 0; index < length; index++) {
                                // not with [index], but[0], because the deleteObetainedClass changed, eachtime when we delete a classname from it.
                                // We need to delete the first stack of this array as much times as the length.
                                deleteObtainedClass[0].className = ''
                            }
                        }

                        this.learningContents.forEach(element => {
                            var dom = document.getElementById(element);

                            if (dom) {
                                dom.closest('tr').className = 'obtained';
                            }
                        });
                    }
                }, 0);
            },

            selectDependency(id, name) {
                this.dependency = id
                this.dependency_name = name
            },

            removeDependency() {
                this.dependency = null
            },

            showAddButton(id) {
                return !(id === this.dependency);
            },

            /**
             * When submit, send the seleted learning contents data back to FormFields.
             */
            submit() {
                EventBus.$emit('submit', {
                    id: this.selected,
                    name: this.name,
                    type: this.type,
                    dependency: this.dependency,
                    dependency_name:this.dependency_name,
                    comment: this.comment
                })
                this.$emit('close')
            },

            setColorOfColoredLetterSquare(type) {
                switch (type) {
                    case this.trans('learning_contents.type.image'):
                        return '#79bc52';
                    case this.trans('learning_contents.type.video'):
                        return '#f8cc99';
                    case this.trans('learning_contents.type.pdf'):
                        return '#d65c5c';
                    case this.trans('learning_contents.type.dlc'):
                        return '#e899ca';
                    case this.trans('learning_contents.type.wbt'):
                        return '#f48fb1';
                }
            }

        }
    }
</script>
